import * as React from 'react'
import { connect } from 'react-redux'
import { RootState } from 'src/core/redux/reducer/index'
import { compose } from 'redux'
import autobind from 'autobind-decorator'
import { TagCloud } from 'react-tagcloud'
import { getClouds } from 'src/core/redux/action/newsAction'
import './tagCloud.css'
import { NewsCriteria } from 'src/type/criteria/newsCriteria'
import { Typography, Icon, Theme, createStyles, WithStyles, withStyles } from '@material-ui/core'
import {css} from '../../conf/style'
import { WithI18n, withI18n } from 'src/core/i18n/withI18n'
import {isEmpty} from 'lodash'

const styles = (t: Theme) => createStyles({
  root: {
    ...css.flexJcCenter,
    flexDirection: 'column',
  },
  cloud: {
    ...css.flexFullCenter,
    flexGrow: 1,
  },
  tagsCloudTitle: {
    ...css.flexFullCenter,
    color: t.palette.primary.main
  },
  i: {
    marginRight: t.spacing.unit,
  },
  label: {
    letterSpacing: 1,
    fontSize: t.typography.fontSize
  },
});

interface IProps extends WithI18n,
  WithStyles<typeof styles>,
  ReturnType<typeof state2props>,
  ReturnType<typeof dispatch2props> {
    onFilter?: (tags: any) => void;
}

class NewsTagCloud extends React.Component<IProps, {}> {

  render() {
    const {clouds, classes, t} = this.props

    return (
       <div className={classes.root}>
          <Typography variant="body2" align="center" className={classes.tagsCloudTitle}>
            <Icon className={classes.i}>cloud</Icon>
            <span className={classes.label}>{t.cloud_tags}</span>
          </Typography>
          <div className={classes.cloud}>
            {!isEmpty(clouds) &&
                  <TagCloud 
                      minSize={0.5}
                      maxSize={2}
                      tags={this.cloudsSizeGenerated()}
                      onClick={this.handleClick} 
                      renderer={this.customRenderer} 
                  />
            }
            {isEmpty(clouds) &&
              <div className="padding-box">
                <Typography variant="caption" align="center" className="text-italic">Aucun tag disponible</Typography>
              </div>
            }
          </div>
       </div>
    )
  }

  componentDidMount() {
      this.props.fetch({category_actu: 'economique'} as NewsCriteria)
  }

  @autobind
  private handleClick(tags){
    this.props.onFilter(tags)
  }

  @autobind
  private customRenderer(tag, size, color){
    return (
      <span key={tag.value}
        style={{
        /*
          animation: `${this.animationRenderer()} 8s linear infinite`,   // must add keyframes blinker
        */
        animationDelay: `${Math.random() * 2}s`,
        fontSize: `${Math.max(tag.count, 1)}em`,  // minimum size acceptable is 0.5em
        margin: '3px',
        padding: '3px',
        display: 'inline-block',
        color: `#0cf`,
        cursor: 'pointer',
        // textShadow: 'rgba(0, 0, 0, 0.3) 1px 3px 7px'
      }}>{tag.value}</span>
    )
  }

  // This fonction is temporary, TODO: improve solution for responsive size tags clouds
  private cloudsSizeGenerated(){
    const { clouds } = this.props
    if(clouds){
      const temps = [];
      for (const key in clouds) {
        if( clouds.hasOwnProperty(key) ) {
          temps.push(Math.pow(clouds[key].count, 2))
        } 
      }  
      const valMax = Math.max(...temps)
      const newsSize = Array.from(temps, v => parseFloat((((v*2)/valMax).toFixed(2))))
      
      for (const key in clouds) {
        if( clouds.hasOwnProperty(key) ) {
          clouds[key].count = newsSize[key]
        } 
      } 
    } 
    return clouds
  }

}

const state2props = (state: RootState) => ({
    clouds: state.clouds.entity
})

const dispatch2props = (dispatch: any, ownProps: any) => ({
    fetch: (c?: NewsCriteria) => dispatch(getClouds(c))
})

export default compose(
  withI18n,
  withStyles(styles),
  connect(state2props, dispatch2props),
)(NewsTagCloud)



// WEBPACK FOOTER //
// ./src/shared/News/NewsTagCloud.tsx